import { createSelector } from '@reduxjs/toolkit';
const reduxAssetLinksReducer = (state) => state.reduxAssetLinks;
export const reduxAssetLinksDataSelector = createSelector(reduxAssetLinksReducer, (reducer) => reducer.data);
